var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i/error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-4---UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AU1.3",
    transform: "translate(-41.000000, -141.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screen",
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(25.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i/error",
    transform: "translate(17.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,16 C32,7.16333006 24.8366883,0 16,0 C7.16355589,0 0,7.16333006 0,16 C0,24.8366699 7.16355589,32 16,32 C24.8366883,32 32,24.8366699 32,16 Z",
    id: "Path",
    fill: "#F36986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8703091,3.40649412 C28.003968,6.12524412 29.2766425,9.55224612 29.2766425,13.2766113 C29.2766425,22.1130371 22.1130866,29.2766113 13.2766425,29.2766113 C9.55214043,29.2766113 6.12529568,28.0039062 3.4063335,25.8701172 C6.33553603,29.6022949 10.8878138,32 16,32 C24.8366883,32 32,24.8366699 32,16 C32,10.8876953 29.6023808,6.33544925 25.8703091,3.40649412 Z",
    id: "Path",
    fill: "#FC476E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0160397,18.6875 L14.9839603,18.6875 C14.581549,18.6875 14.2553224,18.3613281 14.2553224,17.9587402 L14.2553224,8.75878906 C14.2553224,8.35620119 14.581549,8.03002931 14.9839603,8.03002931 L17.0160397,8.03002931 C17.418451,8.03002931 17.7449218,8.35620119 17.7449218,8.75878906 L17.7449218,17.9587402 C17.7449218,18.3613281 17.4186952,18.6875 17.0160397,18.6875 L17.0160397,18.6875 Z",
    id: "Path",
    fill: "#FFD2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0162839,8.03002931 L15.6994125,8.03002931 C16.1018238,8.03002931 16.4280504,8.35620119 16.4280504,8.75878906 L16.4280504,17.9587402 C16.4280504,18.3613281 16.1018238,18.6875 15.6994125,18.6875 L17.0162839,18.6875 C17.4186952,18.6875 17.7449218,18.361084 17.7449218,17.9587402 L17.7449218,8.75878906 C17.7449218,8.35620119 17.4186952,8.03002931 17.0162839,8.03002931 L17.0162839,8.03002931 Z",
    id: "Path",
    fill: "#FFBBD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,24.487793 C15.0364594,24.487793 14.2553224,23.706543 14.2553224,22.7431641 L14.2553224,22.7426758 C14.2553224,21.7792969 15.0364594,20.9980469 16,20.9980469 C16.9635407,20.9980469 17.7449218,21.7792969 17.7449218,22.7426758 L17.7449218,22.7431641 C17.7449218,23.706543 16.9635407,24.487793 16,24.487793 L16,24.487793 Z",
    id: "Path",
    fill: "#FFD2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,20.9980469 C15.8595956,20.9980469 15.7230981,21.0151367 15.5922167,21.0463867 C16.3591912,21.2302246 16.9293552,21.9196777 16.9293552,22.7429199 C16.9293552,23.565918 16.3591912,24.2556152 15.5922167,24.439209 C15.7230981,24.4707031 15.8595956,24.487793 16,24.487793 C16.9637848,24.487793 17.7449218,23.706543 17.7449218,22.7429199 C17.7449218,21.7792969 16.9635407,20.9980469 16,20.9980469 L16,20.9980469 Z",
    id: "Path",
    fill: "#FFBBD7"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.3c3007801f530eed195cdb13403e9e73.svg";
export { ForwardRef as ReactComponent };